import { useEffect, useState } from "react";
import { Phone, MessageCircle, X } from "lucide-react";
import { COMPANY } from "../lib/constants";

// WhatsApp number (no plus, no spaces) — from COMPANY.phone
const WHATSAPP_NUMBER = "393515897637";
const WA_PREFILL = encodeURIComponent(
  "Buongiorno, vorrei informazioni sui vostri impianti fotovoltaici."
);

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="floating-contact"
      className="fixed bottom-24 md:bottom-6 right-4 md:right-6 z-[60] flex flex-col items-end gap-3"
    >
      {open && (
        <div className="flex flex-col gap-3 animate-fade-up">
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WA_PREFILL}`}
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp"
            className="group inline-flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-xl hover:shadow-2xl hover:-translate-y-0.5 transition-all"
          >
            <MessageCircle className="h-5 w-5" />
            <span className="text-sm font-medium">Scrivici su WhatsApp</span>
          </a>
          <a
            href={COMPANY.phoneHref}
            data-testid="floating-call"
            className="group inline-flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#0F5132] text-white shadow-xl hover:shadow-2xl hover:-translate-y-0.5 transition-all"
          >
            <Phone className="h-5 w-5" />
            <span className="text-sm font-medium">Chiama ora</span>
          </a>
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Chiudi" : "Contattaci"}
        data-testid="floating-contact-toggle"
        className={`relative h-14 w-14 rounded-full text-white shadow-2xl flex items-center justify-center transition-all duration-300 ${
          open ? "bg-[#0A3622] rotate-90" : "bg-[#0F5132] hover:bg-[#0A3622]"
        }`}
      >
        {open ? (
          <X className="h-6 w-6" />
        ) : (
          <>
            <MessageCircle className="h-6 w-6" />
            <span className="absolute -top-1 -right-1 h-3.5 w-3.5 rounded-full bg-[#D97706] ring-2 ring-white animate-pulse" />
          </>
        )}
      </button>
    </div>
  );
}
